import { GA_EXCLUDED_PATH_PREFIXES } from './constants';

export function isPathExcludedFromGaPageViews(pathname: string): boolean {
  const path = pathname.trim() || '/';
  return GA_EXCLUDED_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

export function isGaEnabledForPath(pathname: string): boolean {
  return !isPathExcludedFromGaPageViews(pathname);
}
